// extracted by mini-css-extract-plugin
module.exports = {"buttonSmTransparentPrimary":"ButtonSmTransparentPrimary_buttonSmTransparentPrimary__12J5_"};